<template>
  <div class="bodys">
    <!-- class="box" style="box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%)" -->
    <div class="topBtns">
      <i
        class="el-icon-close"
        style="font-size: 25px; cursor: pointer"
        @click="backOff"
      ></i>
      <div>
        <span class="topBtn" v-if="detailedData.AllowEdit == 1">
          <el-button
            type="success"
            size="mini"
            @click="preservation(1)"
            :loading="editLoading"
            >保存草稿</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="preservation(2)"
            :loading="editLoading"
            >发布</el-button
          >
        </span>
        <el-button
          type="success"
          size="mini"
          @click="fileClick()"
          :loading="editLoading"
          v-if="this.detailedData.AllowPlaceFile"
          >归档</el-button
        >
        <span
          v-if="
            detailedData.AllowEdit != 1 &&
            detailedData.AllowEditDtlColumn &&
            detailedData.AllowEditDtlColumn.indexOf('o12,') == -1 &&
            detailedData.AllowEditDtlColumn.indexOf('o14,') == -1
          "
        >
          <el-button
            type="success"
            size="mini"
            @click="preservation(4)"
            :loading="editLoading"
            >暂存</el-button
          >
          <el-button
            type="primary"
            size="mini"
            @click="preservation(3)"
            class="topBtn"
            :loading="editLoading"
            >提交</el-button
          >
        </span>
        <el-button 
          v-if=" detailedData.AllowEditDtlColumn.indexOf('o12,') != -1 ||
            detailedData.AllowEditDtlColumn.indexOf('o14,') != -1"
          class="topBtn"
          type="success" 
          size="mini" 
          @click="preservation(4, 100)"
        >
          保存草稿
        </el-button>
        <!-- <span v-if="stateName && stateName != '新增' && stateName != '草稿'">
          <el-button
            type="success"
            :loading="exportLoading"
            size="mini"
            @click="exportExcel"
            >导出excel</el-button
          >
          <el-button
            type="primary"
            :loading="exportLoading"
            size="mini"
            >导出word</el-button
          >
        </span> -->
      </div>
    </div>
    <div class="box">
      <div class="box_top">
        <div class="box_h3">项目信息</div>
        <p class="box_topA" @click="boxFalseOne = !boxFalseOne">
          {{ boxFalseOne ? "收起" : "展开" }}
        </p>
      </div>
      <div v-if="boxFalseOne">
        <div class="aboutDiv">
          <div>
            <div class="projectStyle">
              <p>项目名称:</p>
              <el-autocomplete
                v-if="detailedData.AllowEdit == 1"
                clearable
                class="inline-input"
                v-model="keyGJZ"
                :fetch-suggestions="querySearch"
                placeholder="请输入内容"
                @select="handleSelect"
                @clear="handleSelect(1)"
              ></el-autocomplete>

              <p
                style="width: 300px; text-align: left; white-space: nowrap"
                v-else
              >
                {{ keyGJZ }}
              </p>
            </div>

            <div class="projectStyle">
              <p>中心名称:</p>
              <el-select
                class="inline-input"
                v-model="detailedData.Memo10"
                placeholder="请选择"
                v-if="detailedData.AllowEdit == 1"
              >
                <el-option
                  v-for="item in centerNameData"
                  ref="myselect"
                  :key="item.CenterId"
                  :label="item.CenterName"
                  :value="item.CenterName"
                  @click.native="optionClick(item)"
                ></el-option>
              </el-select>
              <p style="width: 200px; text-align: left" v-else>
                {{ detailedData.Memo10 }}
              </p>
            </div>
            <div>
              <p>CRC:</p>
              <el-select
                v-model="CRCName"
                placeholder="请选择"
                clearable
                multiple
                collapse-tags
                v-if="detailedData.AllowEdit == 1 || trueCRC"
              >
                <el-option
                  v-for="item in reportCRCData"
                  :key="item.UserId"
                  :label="item.UserName"
                  :value="`${item.UserId},${item.UserName}`"
                ></el-option>
              </el-select>
              <p style="width: 200px; text-align: left" v-else>
                {{ detailedData.Memo6 }}
              </p>
              <div v-if="detailedData.AllowSetCRC == 1">
                <el-button
                  v-if="!trueCRC"
                  size="mini"
                  type="primary"
                  @click="switchCRCClick"
                  >修改CRC</el-button
                >
                <div v-else style="margin-left: 10px">
                  <el-button
                    :disabled="
                      CRCName.length == 0 ||
                      CRCName.join(',') == detailedData.Memo6
                    "
                    size="mini"
                    type="success"
                    @click="modifyCRCClick"
                    :loading="editLoadingCRC"
                    >确认修改</el-button
                  >
                  <el-button
                    size="mini"
                    type="danger"
                    @click="
                      trueCRC = false;
                      CRCName = detailedData.Memo6.split(',');
                    "
                    >取消</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div>
            <div>
              <p>项目部门:</p>
              {{ detailedData.Memo19 }}
            </div>
            <div>
              <p>中心编号:</p>
              {{ detailedData.Memo9 }}
            </div>
            <div>
              <p>申办方:</p>
              {{ detailedData.Memo13 }}
            </div>

            <div
              :style="{ width: `${(detailedData.Memo10.length + 5) * 15}px` }"
            >
              <p>中心名称:</p>
              {{ detailedData.Memo10 }}
            </div>
            <div>
              <p>项目经理:</p>
              {{ detailedData.Memo14 }}
            </div>
            <div>
              <p>项目级别:</p>
              {{ detailedData.Memo20 }}
            </div>
            <div>
              <p>项目归属:</p>
              {{ detailedData.Memo21 }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box_top">
        <div class="box_h3">项目报告</div>
        <p class="box_topA" @click="boxFalseTwo = !boxFalseTwo">
          {{ boxFalseTwo ? "收起" : "展开" }}
        </p>
      </div>
      <table class="tableStyle" v-if="boxFalseTwo">
        <thead>
          <tr>
            <th>报告类型</th>
            <th>研究阶段</th>
            <th colspan="2">质控或核查原因</th>
            <th>适应症</th>
            <th>中心所在城市</th>
            <th>省份</th>
            <!-- <th style="min-width: 150px">CRC姓名</th> -->
            <th>crc直线汇报领导</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <el-select
                :disabled="detailedData.AllowEdit != 1"
                v-model="detailedData.TemplateId"
                placeholder="请选择"
                clearable
                @change="TemplateIdChange"
              >
                <el-option
                  v-for="item in TemplateData"
                  :key="item.TemplateId"
                  :label="item.Name"
                  :value="item.TemplateId"
                ></el-option>
              </el-select>
            </td>
            <td>
              <el-select
                :disabled="detailedData.AllowEdit != 1"
                v-model="detailedData.Memo1"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in stageRData"
                  :key="item.CateName"
                  :label="item.CateName"
                  :value="item.CateName"
                ></el-option>
              </el-select>
            </td>
            <td colspan="2">
              <el-select
                :disabled="detailedData.AllowEdit != 1"
                v-model="detailedData.Memo2"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in QCAReason"
                  :key="item.CateName"
                  :label="item.CateName"
                  :value="item.CateName"
                ></el-option>
              </el-select>
              <!-- <el-input
                v-model="detailedData.Memo2"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>-->
            </td>
            <td>
              <el-input
                v-model="detailedData.Memo3"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
              <!-- {{ detailedData.Memo3 }} -->
            </td>
            <td>
              <el-input
                v-model="detailedData.Memo4"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
              <!-- {{ detailedData.Memo4 }} -->
            </td>
            <td>
              <el-input
                v-model="detailedData.Memo5"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
              <!-- {{ detailedData.Memo5 }} -->
              <!-- 
              <el-cascader
                placeholder="请选择工作地"
                :options="cityCascaders"
                expand-trigger="click"
                :props="cascaderProps"
                size="mini"
                v-model="detailedData.CityId"
                :show-all-levels="false"
                change-on-select
                filterable
                clearable
              ></el-cascader>-->
            </td>
            <!-- <td>
              <el-select
                v-model="CRCName"
                placeholder="请选择"
                clearable
                multiple
              >
                <el-option
                  v-for="item in reportCRCData"
                  :key="item.UserId"
                  :label="item.CRCName"
                  :value="`${item.UserId},${item.CRCName}`"
                >
                </el-option>
              </el-select>
            </td>-->
            <td>
              <el-input
                v-model="detailedData.Memo8"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th>中心编号</th>
            <th>中心名称</th>
            <th>研究科室</th>
            <th>主要研究者（PI）</th>
            <th>申办方</th>
            <th>普蒂德PM姓名</th>
            <th>试验分期</th>
            <th>报告发出日期</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <el-input
                v-model="detailedData.Memo9"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="detailedData.Memo10"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="detailedData.Memo11"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="detailedData.Memo12"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="detailedData.Memo13"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="detailedData.Memo14"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
            <td>
              <el-input
                v-model="detailedData.Memo15"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
            <td class="date">
              {{ detailedData.CallDate }}
              <!-- <el-date-picker
                :disabled="detailedData.AllowEdit != 1"
                v-model="detailedData.CallDate"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>-->
            </td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <th>核查人员</th>
            <th>核查日期</th>
            <th>报告撰写者</th>
            <th colspan="2">项目情况</th>
            <th colspan="2">核查例数及筛选号</th>
            <th>核查内容</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <el-input
                v-model="detailedData.Memo16"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
            <td class="date">
              <!-- <el-date-picker
                v-model="detailedData.Memo17"
                type="date"
                placeholder="选择日期"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>-->
              <el-date-picker
                :disabled="detailedData.AllowEdit != 1"
                v-model="detailedDataMemo17"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                format="MM-dd"
              ></el-date-picker>
            </td>
            <td>
              <el-input
                v-model="detailedData.UserName"
                :disabled="detailedData.AllowEdit != 1"
              ></el-input>
            </td>
            <td colspan="2" class="specialInput">
              <div class="testDiv">
                <div>
                  <div>
                    筛选
                    <el-input
                      :disabled="detailedData.AllowEdit != 1"
                      v-model="situationProject[0]"
                      type="number"
                    ></el-input
                    >例
                  </div>
                  <div>
                    疾病进展出组
                    <el-input
                      :disabled="detailedData.AllowEdit != 1"
                      v-model="situationProject[5]"
                      type="number"
                    ></el-input
                    >例
                  </div>
                </div>
                <div>
                  <div>
                    入组
                    <el-input
                      :disabled="detailedData.AllowEdit != 1"
                      v-model="situationProject[1]"
                      type="number"
                    ></el-input
                    >例
                  </div>
                  <div>
                    生存随访
                    <el-input
                      :disabled="detailedData.AllowEdit != 1"
                      v-model="situationProject[6]"
                      type="number"
                    ></el-input
                    >例
                  </div>
                </div>
                <div>
                  <div>
                    在随访
                    <el-input
                      :disabled="detailedData.AllowEdit != 1"
                      v-model="situationProject[2]"
                      type="number"
                    ></el-input
                    >例
                  </div>
                  <div>
                    死亡
                    <el-input
                      :disabled="detailedData.AllowEdit != 1"
                      v-model="situationProject[7]"
                      type="number"
                    ></el-input
                    >例
                  </div>
                </div>
                <div>
                  <div>
                    完成
                    <el-input
                      :disabled="detailedData.AllowEdit != 1"
                      v-model="situationProject[3]"
                      type="number"
                    ></el-input
                    >例
                  </div>
                  <div>
                    其中SAE
                    <el-input
                      :disabled="detailedData.AllowEdit != 1"
                      v-model="situationProject[8]"
                      type="number"
                    ></el-input
                    >例
                  </div>
                </div>
                <div>
                  <div>
                    脱落
                    <el-input
                      :disabled="detailedData.AllowEdit != 1"
                      v-model="situationProject[4]"
                      type="number"
                    ></el-input
                    >例
                  </div>
                </div>
              </div>
            </td>
            <td colspan="2">
              <el-input
                type="textarea"
                :disabled="detailedData.AllowEdit != 1"
                v-model="detailedData.Memo22"
              ></el-input>
            </td>
            <td>
              <el-input
                v-if="detailedData.AllowEdit != 1"
                type="textarea"
                v-model="detailedData.Memo23"
                :disabled="true"
              ></el-input>
              <el-select
                v-else
                v-model="detailedDataMemo23"
                placeholder="请选择"
                clearable
                multiple
                collapse-tags
              >
                <el-option
                  v-for="item in dictAudit"
                  :key="item.ConfigCateId"
                  :label="item.CateName"
                  :value="item.CateName"
                ></el-option>
              </el-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="box">
      <div class="box_top">
        <div class="box_h3">项目详情</div>
        <p class="box_topA" @click="boxFalseThree = !boxFalseThree">
          {{ boxFalseThree ? "收起" : "展开" }}
        </p>
      </div>
      <ProjectInfo
        :tableData="TemplateData2"
        :AllowEdit="detailedData.AllowEdit"
        ref="childs"
        v-show="boxFalseThree"
        :isDefaultRefuse="detailedData.AllowEditDtlColumn.indexOf('o12,') != -1 ||
        detailedData.AllowEditDtlColumn.indexOf('o14,') != -1"
      ></ProjectInfo>
      <!-- <table class="tableStyle" v-if="boxFalseThree">
        <thead>
          <tr>
            <th>内容分类</th>
            <th>问题类别</th>
            <th>其他问题类别 （如选择“其他”请描述）</th>
            <th>严重程度分级</th>
            <th>问题描述</th>
            <th>参考依据</th>
            <th>纠正和预防措施（CRC填写）</th>
            <th>负责人</th>
            <th>计划完成日期</th>
            <th>实际完成日期</th>
            <th>文件资料支持（如需）</th>
            <th>备注（无需整改或未能整改的在此说明）</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <el-cascader
                v-model="answerData.ItemLabel"
                :options="TemplateData2"
                :props="{
                  expandTrigger: 'hover',
                  children: 'Children',
                  label: 'ItemLabel',
                }"
                @change="handleNodeClick"
              ></el-cascader>
            </td>
            <td>
              <el-select
                v-model="answerData.Memo1"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in [
                    'NA',
                    '未查',
                    '未发现问题',
                    '优',
                    '良',
                    '一般',
                    '差',
                    '其他，请说明：',
                  ]"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </td>
            <td>
              <el-input v-model="answerData.Memo2"></el-input>
            </td>
            <td>
              <el-select
                v-model="answerData.Memo3"
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in ['NA', '严重', '重要', '轻微']"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>
            </td>
            <td><el-input v-model="answerData.Memo4"></el-input></td>
            <td>
              <el-input v-model="answerData.Memo5"></el-input>
            </td>
            <td>{{ answerData.Memo6 }}</td>
            <td>{{ answerData.Memo7 }}</td>
            <td>{{ answerData.Memo8 }}</td>
            <td>{{ answerData.Memo9 }}</td>
            <td>{{ answerData.Memo10 }}</td>
            <td>{{ answerData.Memo11 }}</td>
          </tr>
        </tbody>
      </table>-->
    </div>
    <div
      class="box"
      v-if="
        detailedData.AllowEditDtlColumn.indexOf('o12,') != -1 ||
        detailedData.AllowEditDtlColumn.indexOf('o14,') != -1
      "
    >
      <div class="box_top">
        <div class="box_h3">综合意见</div>
        <p class="box_topA" @click="boxFalseFour = !boxFalseFour">
          {{ boxFalseFour ? "收起" : "展开" }}
        </p>
      </div>
      <!-- <table class="tableStyle" v-if="boxFalseFour">
        <thead>
          <tr>
            <th>审批类型</th>
            <th>审批阶段</th>
            <th>原因</th>
            <th>日期</th>
            <th>审批</th>
            <th>审批意见</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              {{ detailedData.valu }}
            </td>
            <td>
              {{ detailedData.valu }}
            </td>
            <td>{{ detailedData.valu }}</td>
            <td>{{ detailedData.valu }}</td>
            <td>
              <el-button type="primary" size="mini">批准</el-button>
              <el-button type="danger" size="mini">拒绝</el-button>
            </td>
            <td>
              {{ detailedData.valu }}
            </td>
            <td>{{ detailedData.Sponsor }}</td>
          </tr>
        </tbody>
      </table>-->
      <div v-if="boxFalseFour">
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 20px;
          "
        >
          <p style="margin-right: 10px">备注：</p>
          <el-input
            style="width: 300px"
            v-model="AuthComments"
            type="textarea"
            ref="AuthCommentsref"
          ></el-input>
        </div>
        <div style="display: flex; justify-content: center">
          <el-button type="primary" size="mini" @click="agreeTotal"
            >批准</el-button
          >
          <el-button type="danger" size="mini" @click="refuseTotal"
            >拒绝</el-button
          >
        </div>
      </div>
    </div>
    <div class="box">
      <div class="box_top">
        <div class="box_h3">操作日志</div>
        <p class="box_topA" @click="boxFalseFive = !boxFalseFive">
          {{ boxFalseFive ? "收起" : "展开" }}
        </p>
      </div>
      <div
        v-if="boxFalseFive"
        class="box_card"
        style="box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%)"
      >
        <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item
            ><span style="color: #67c23a">开始</span></el-breadcrumb-item
          >
          <el-breadcrumb-item
            ><span style="color: #000">通过审核</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>结束</el-breadcrumb-item>
        </el-breadcrumb>-->
        <!-- <el-timeline>
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            :timestamp="activity.timestamp"
            :color="activity.color"
            :icon="activity.icon"
          >
            {{ activity.content }}
          </el-timeline-item>
        </el-timeline>-->
        <el-timeline
          v-if="
            detailedData.WorkFlowList && detailedData.WorkFlowList.length > 0
          "
        >
          <el-timeline-item
            v-for="(activity, index) in this.detailedData.WorkFlowList"
            :key="index"
            :timestamp="activity.FlowTimes"
            color="#0bbd87"
            >{{ activity.Name }}</el-timeline-item
          >
        </el-timeline>
      </div>
    </div>
  </div>
</template>

<script>
import {
  AllCitiesCascaderOption,
  RegionCenterTree,
  GetObjectList,
  GetProjectCenterUserList,
  GetTemplatesList,
  SetQualityRptList,
  GetDictValue,
  GetQualityRptList,
  AuthCallList,
} from "../../api/api";
import ProjectInfo from "./ProjectInfo.vue";
import Vue from "vue";
import uuidv4 from "uuid/v4";
import addWatermark from '@/utils/watermark.js' // 引入水印方法
import moment from "moment";
export default {
  name: "reportQualityScreen",
  components: {
    ProjectInfo,
  },
  data() {
    return {
      exportLoading: false,
      editLoadingCRC: false,
      trueCRC: false,
      stateName: "",
      AuthComments: "",
      detailedDataMemo23: [],
      editLoading: false,
      QCAReason: [],
      stageRData: [],
      detailedDataMemo17: [],
      answerData: {},
      keyGJZ: "",
      TemplateData: [],
      TemplateData1: [],
      TemplateData2: [],
      defaultProps: {
        children: "Children",
        label: "ItemLabel",
      },
      activities: [
        {
          content: "开始",
          timestamp: "2022-04-15",
          color: "#67c23a",
          icon: "el-icon-check",
        },
        {
          content: "通过审核",
          timestamp: "2022-04-13",
          color: "#000",
        },
        {
          content: "结束",
          timestamp: "2022-04-11",
          color: "#c0c4cc",
        },
      ],
      boxFalseOne: true,
      boxFalseTwo: true,
      boxFalseThree: true,
      boxFalseFour: true,
      boxFalseFive: true,
      cascaderProps: { label: "Name", value: "Key", children: "Children" },
      cityCascaders: [],
      detailedData: {
        CallReportDetail: [
          {
            Id: 0,
            UUID: uuidv4(),
            CallReportId: 0,
            TemplateItemId: 0,
            Memo1: "",
            Memo2: "",
            Memo3: "",
            Memo4: "",
            Memo5: "",
            Memo6: "",
            Memo7: "",
            Memo8: "",
            Memo9: "",
            Memo10: "",
            Memo11: "",
            Memo12: "",
            Memo13: "",
            Memo14: "",
            Memo15: "",
            Memo16: "",
            Memo17: "",
            Memo18: "",
            Memo19: "",
            Memo20: "",
            Memo21: "",
            Memo22: "",
            Memo23: "",
            Memo24: "",
            Memo25: "",
            Memo26: "",
            Memo27: "",
            Memo28: "",
            Memo29: "",
            Memo30: "",
            Memo31: "",
            Memo32: "",
            Memo33: "",
            Memo34: "",
            Memo35: "",
            Memo36: "",
            Memo37: "",
            Memo38: "",
            Memo39: "",
            Memo40: "",
            Memo41: "",
            Memo42: "",
            Memo43: "",
            Memo44: "",
            Memo45: "",
            Memo46: "",
            Memo47: "",
            Memo48: "",
            Memo49: "",
            Memo50: "",
            AddTime: "",
            AddUserId: 0,
            EditTime: "",
            EditUserId: 0,
            IsValid: 0,
          },
        ],
        WorkFlowList: [],
        CallReportId: 0,
        UUID: uuidv4(),
        UserId: 0,
        TemplateId: "",
        CallDate: "",
        ProjectId: 0,
        CenterId: 0,
        Memo1: "",
        Memo2: "",
        Memo3: "",
        Memo4: "",
        Memo5: "",
        Memo6: "",
        Memo7: "",
        Memo8: "",
        Memo9: "",
        Memo10: "",
        Memo11: "",
        Memo12: "",
        Memo13: "",
        Memo14: "",
        Memo15: "",
        Memo16: "",
        Memo17: "",
        Memo18: "",
        Memo19: "",
        Memo20: "",
        Memo21: "",
        Memo22: "",
        Memo23: "",
        Memo24: "",
        Memo25: "",
        Memo26: "",
        Memo27: "",
        Memo28: "",
        Memo29: "",
        Memo30: "",
        Memo31: "",
        Memo32: "",
        Memo33: "",
        Memo34: "",
        Memo35: "",
        Memo36: "",
        Memo37: "",
        Memo38: "",
        Memo39: "",
        Memo40: "",
        Memo41: "",
        Memo42: "",
        Memo43: "",
        Memo44: "",
        Memo45: "",
        Memo46: "",
        Memo47: "",
        Memo48: "",
        Memo49: "",
        Memo50: "",
        UserName: "",
        AllowEdit: 1,
        AllowPlaceFile: 0,
        AllowDel: 0,
        AllowAuth: 0,
        AllowEditDtlColumn: "",
      },
      defaultPropsCenterKey: {
        children: "Children",
        label: "RegionName",
        value: "RegionName",
        emitPath: false,
      },

      PropsCenterKey: {
        children: "Children",
        label: "RegionName",
        value: "RegionName",
        emitPath: false,
      },
      situationProject: [],
      dataForm: [
        {
          Amount: 900005,
          CaseCount: 320,
          CenterCount: 120,
          Department: "MA",
          Indications: "恒瑞-肿瘤",
          JoinGroupCount: 1,
          MtExeAmount: 0,
          MtTolWorkTimes: 0,
          MtVisitCount: 0,
          NextVisitCount: 0,
          NextVisitExeAmount: 0,
          NextVisitTimes: 0,
          Ownership: "非肿瘤",
          PM: "高品",
          PlanCount: null,
          ProjectCode: "恒瑞-执行额02",
          ProjectLevel: "",
          ProjectPayType: "工时",
          ProjectStatus: "",
          ProjectType: "非肿瘤",
          ScreenCount: 0,
          SinglePrice: 590,
          Sponsor: "恒瑞-申办方",
          Stages: "IIT",
          TolExeAmount: 0,
          TolJoinGroupCount: 1,
        },
        {
          Amount: 900005,
          CaseCount: 320,
          CenterCount: 120,
          Department: "MA",
          Indications: "恒瑞-肿瘤",
          JoinGroupCount: 1,
          MtExeAmount: 0,
          MtTolWorkTimes: 0,
          MtVisitCount: 0,
          NextVisitCount: 0,
          NextVisitExeAmount: 0,
          NextVisitTimes: 0,
          Ownership: "非肿瘤",
          PM: "高品",
          PlanCount: null,
          ProjectCode: "恒瑞-执行额02",
          ProjectLevel: "",
          ProjectPayType: "工时",
          ProjectStatus: "",
          ProjectType: "非肿瘤",
          ScreenCount: 0,
          SinglePrice: 590,
          Sponsor: "恒瑞-申办方",
          Stages: "IIT",
          TolExeAmount: 0,
          TolJoinGroupCount: 1,
        },
      ],
      projectList: [],
      add: 0,
      centerNameData: [],
      centerCRCData: [],
      reportCRCData: [],
      CRCName: [],
      dictAudit: [],
      imglist: [
        {
          imgUrl:
            "https://img2.baidu.com/it/u=2709954499,581919391&fm=253&fmt=auto&app=138&f=JPEG?w=468&h=518",
        },
        {
          imgUrl:
            "https://img0.baidu.com/it/u=1462004956,1440895436&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=353",
        },
      ],
      autoSaveTimer: null,
      autoSaveState: true,
    };
  },
  watch: {
    TemplateData2: {
      handler(newVal, oldVal) {
        if(this.autoSaveState && oldVal.length !== 0) {
          const state = this.detailedData.AllowEditDtlColumn.indexOf('o12,') != -1 || this.detailedData.AllowEditDtlColumn.indexOf('o14,') != -1
          if(state) {
            this.autoSaveState = false;
            console.log('开始自动保存草稿',)
            this.autoSaveTimer = setInterval(() => {
              this.preservation(4, 100, 'automatic');
              console.log('自动保存草稿成功',);
            }, 300000);
          }
        }
      },
      deep: true,
    },
  },
  created() {
    window.addEventListener("beforeunload", this.tipMethod);
  },
  beforeDestroy() {
    clearInterval(this.autoSaveTimer); // 销毁定时器
  },
  destroyed() {
    // 在组件生命周期结束的时候销毁。
    window.removeEventListener("beforeunload", this.tipMethod);
  },
  mounted() {
    // 添加水印
    const userInfo = JSON.parse(localStorage.getItem("cur-user-info"));
    if(userInfo.showWatermark) {
      const time = moment().format("YYYY-MM-DD");
      addWatermark({
        content: userInfo.UserName + time,
      });
    }

    this.getCitiesCascaderOption();
    this.initDict();
    if (
      !this.detailedData.UserName &&
      JSON.parse(window.localStorage.getItem("cur-user-info"))
    )
      this.detailedData.UserName = JSON.parse(
        window.localStorage.getItem("cur-user-info")
      ).UserName;

    if (this.$route.query.id != 0) {
      this.getDetailedData();
    } else {
      this.detailedData.AllowEditDtlColumn = "Memo1,Memo2,Memo3,Memo4,Memo5";
      this.getData();
      window.sessionStorage.setItem("stateName", "新增");
    }
    this.add = window.sessionStorage.getItem("add");

    this.getWorkProjectList();
  },
  methods: {
    getDetailedData() {
      GetQualityRptList({
        Types: 0,
        CallReportId: this.$route.query.id,
        ProjectId: 0,
        ProjectName: "",
        CenterName: "",
        ProjectType: "",
        Indications: "",
        Stages: "",
        Progress: "",
        Steps: "",
        PMName: "",
        SWName: "",
        sw: "",
        DepName: "",
        sw1: "",
        sw2: "",
        sw3: "",
        PageIndex: 0,
        PageSize: 20,
        Skip: 0,
        RequetUrl: "",
      }).then((res) => {
        if (res.data.Code != 1) this.$message.error(res.data.Msg);
        this.detailedData = res.data.Data[0];
        this.stateName = this.detailedData.Memo50;
        window.sessionStorage.setItem("stateName", this.detailedData.Memo50);

        this.keyGJZ = this.detailedData.ProjectCode;
        if (this.detailedData.Memo18) {
          this.situationProject = this.detailedData.Memo18.split(",");
        }
        if (this.detailedData.Memo23) {
          this.detailedDataMemo23 = this.detailedData.Memo23.split(",");
        }
        if (this.detailedData.Memo6) {
          this.CRCName = this.detailedData.Memo6.split(",");
        }
        if (this.detailedData.Memo17) {
          this.detailedDataMemo17 = this.detailedData.Memo17.split(",");
        }
        if (
          this.detailedData.CallReportDetail &&
          this.detailedData.CallReportDetail.length > 0
        ) {
          let str = "";
          this.detailedData.CallReportDetail.forEach((v) => {
            if (str.indexOf("." + v.TemplateItemId + ".") == -1) {
              str += "." + v.TemplateItemId + ".";
            } else {
              v.sonTrue = true;
            }
          });
        }
        this.getData();
      });
    },
    //初始化字典项
    initDict() {
      //项目类型
      var params = {
        PCode: "bus_dict_Audit",
      };
      GetDictValue(params).then((res) => {
        if (res.data.Code != 1) return;
        this.dictAudit = res.data.Data;
      });
      params = {
        PCode: "bus_dict_QCAReason",
      };
      GetDictValue(params).then((res) => {
        if (res.data.Code != 1) return;
        this.QCAReason = res.data.Data;
      });
      params = {
        PCode: "bus_dict_stageR",
      };
      GetDictValue(params).then((res) => {
        if (res.data.Code != 1) return;
        this.stageRData = res.data.Data;
      });
    },
    getData(num) {
      GetTemplatesList(-1).then((res) => {
        this.TemplateData = res.data.Data.Table;
        this.TemplateData1 = res.data.Data.Table1;
        if (num != 1) {
          if (this.detailedData.TemplateId) {
            this.TemplateIdChange();
          }
        }
      });
    },
    handleNodeClick(data) {
      console.log(data);
    },
    TemplateIdChange(test) {
      let arr = [];
      let arrs = [];
      // TemplateData1 重选莫名多数据 暂重新获取数据
      this.getData(1);
      this.TemplateData1.forEach((v) => {
        if (v.TemplateId == this.detailedData.TemplateId) {
          arr.push(v);
        }
      });
      arr.forEach((v) => {
        if (!v.ParentId) {
          arrs.push(v);
        }
      });
      let adds = this.lookSons(arrs, arr);
      this.TemplateData2 = this.formatConversion([], adds);

      let addArr = [];
      this.TemplateData2.forEach((item, l) => {
        delete item.Children;
        for (let i = 1; i < 16; i++) {
          this.$set(item, "Memo" + i, "");
        }
        // 赋值
        if (this.detailedData.CallReportDetail) {
          this.detailedData.CallReportDetail.forEach((v) => {
            if (item.TemplateItemId == v.TemplateItemId) {
              if (v.sonTrue) {
                let add = JSON.parse(JSON.stringify(item));
                add.Id = v.Id;
                for (let i = 1; i < 16; i++) {
                  this.$set(add, "Memo" + i, v[`Memo${i}`]);
                }
                if (v.Memo41) this.$set(add, "Memo41", v.Memo41);
                addArr.push([l + 1, add]);
              } else {
                item.Id = v.Id;
                for (let i = 1; i < 16; i++) {
                  this.$set(item, "Memo" + i, v[`Memo${i}`]);
                }
              }
            }
          });
        }
      });

      addArr.forEach((v, i) => {
        this.TemplateData2.splice(v[0] + i, 0, v[1]);
      });
      //多余的不填写
      this.TemplateData2.forEach((v) => {
        if (
          (this.stateName == "待CRC整改" ||
            this.stateName == "待PM审核" ||
            this.stateName == "待负责人审核") &&
          (v.Memo1 == undefined || v.Memo1 == "")
        ) {
          this.detailedData.AllowEditDtlColumn.split(",").forEach((memo) => {
            v[`${memo}True`] = false;
          });
        }
      });
    },
    formatConversion(
      parent,
      children,
      index = 0,
      family = [],
      elderIdentity = "x"
    ) {
      if (children && children.length > 0) {
        children.map((x, i) => {
          Vue.set(x, "Level", index);
          Vue.set(x, "Family", [...family, elderIdentity + "_" + i]);
          Vue.set(x, "Identity", elderIdentity + "_" + i);
          parent.push(x);
          if (x.Children && x.Children.length > 0)
            this.formatConversion(
              parent,
              x.Children,
              index + 1,
              [...family, elderIdentity + "_" + i],
              elderIdentity + "_" + i
            );
        });
      }
      return parent;
    },
    lookSons(array, data, a = 2) {
      array.forEach((it) => {
        data.forEach((item, i) => {
          if (it.TemplateItemId == item.ParentId) {
            if (!it.Children) it.Children = [];
            //权限
            if (this.detailedData.AllowEditDtlColumn) {
              for (let i = 1; i < 16; i++) {
                if (
                  (this.detailedData.AllowEditDtlColumn + ",").indexOf(
                    "o" + i + ","
                  ) != -1
                ) {
                  item[`Memo${i}True`] = true;
                }
              }
            }

            if (item.DataSrcType) {
              item.DataSrcType.split("|").forEach((v) => {
                item[`${v.split(":")[0]}Type`] = v.split(":")[1];
              });
            }
            if (item.DataSrcCode) {
              item.DataSrcCode.split("|").forEach((v) => {
                item[`${v.split(":")[0]}Code`] = v.split(":")[1];
              });
            }
            item.Levels = a;
            it.Children.push(item);
          }
        });
        if (it.Children && it.Children.length > 0) {
          a++;
          this.lookSons(it.Children, data, a);
        }
        a = 2;
      });

      return array;
    },
    searchCRC(num) {
      if (num == 1) {
        this.detailedData.Memo4 = "";
      }
      GetObjectList({
        objKey: "zl_getzlprojectcenteruser",
        sw1: this.detailedData.ProjectId,
      }).then((res) => {
        if (res.data.Data.Table.length > 0) {
          if (num == 1) {
            this.centerCRCData = res.data.Data.Table;
            this.centerNameData = this.screenPackage1(
              res.data.Data.Table,
              "CenterName",
              "CenterId"
            );
          } else {
            let centerName = [];
            res.data.Data.Table.forEach((v) => {
              if (v.CenterName == this.detailedData.Memo10) {
                centerName.push(v);
              }
            });
            this.reportCRCData = this.screenPackage(centerName, "UserName");
          }
        }
      });
    },
    optionClick(item) {
      this.CRCName = [];
      this.detailedData.CenterId = item.CenterId ? item.CenterId : 0;
      this.detailedData.Memo10 = item.CenterName ? item.CenterName : "";
      this.detailedData.Memo4 = item.CityName ? item.CityName : "";
      this.detailedData.Memo5 = item.RegionName ? item.RegionName : "";
      this.detailedData.Memo9 = item.CenterCode ? item.CenterCode : ""; //中心编号
      this.detailedData.Memo13 = item.Sponsor ? item.Sponsor : ""; //申办方
      this.detailedData.Memo14 = item.PM ? item.PM : ""; //项目经理
      this.detailedData.Memo19 = item.Department ? item.Department : ""; //项目部门
      this.detailedData.Memo20 = item.ProjectLevel ? item.ProjectLevel : ""; //项目级别
      this.detailedData.Memo21 = item.Ownership ? item.Ownership : ""; //项目归属
      this.detailedData.Memo15 = item.Stages ? item.Stages : ""; //项目归属
      this.detailedData.Memo3 = item.Indications ? item.Indications : ""; //适应症
      this.detailedData.Memo11 = item.CenterDepartment
        ? item.CenterDepartment
        : ""; //研究科室

      this.reportCRCData = [];
      this.centerCRCData.forEach((v) => {
        if (item.CenterName == v.CenterName) {
          this.reportCRCData.push(v);
        }
      });
    },
    screenPackage(datas, name) {
      let newDatas = [];
      let str = "";
      newDatas.push(datas[0]);
      str += datas[0][name];
      datas.forEach((v) => {
        if (str.indexOf(v[name]) == -1) {
          str += v[name];
          newDatas.push(v);
        }
      });
      return newDatas;
    },
    screenPackage1(datas, name, value) {
      let newDatas = [];
      // let str = "";
      let str= [] ;
      newDatas.push(datas[0]);
      // str += datas[0][name];
      str.push(datas[0][name]);
      datas.forEach((v) => {
        // if (str.indexOf(v[name]) == -1) {
        //   str += v[name];
        //   newDatas.push(v);
        // }
        if (!str.includes(v[name])) {
          str.push(v[name]);
          newDatas.push(v);
        }
      });
      return newDatas;
    },
    handleSelect(item) {
      this.CRCName = [];
      this.centerNameData = [];
      this.reportCRCData = [];
      this.detailedData.CenterId = 0;
      this.detailedData.Memo10 = "";
      this.detailedData.Memo4 = "";
      this.detailedData.Memo5 = "";
      this.detailedData.Memo9 = ""; //中心编号
      this.detailedData.Memo13 = ""; //申办方
      this.detailedData.Memo14 = ""; //项目经理
      this.detailedData.Memo19 = ""; //项目部门
      this.detailedData.Memo20 = ""; //项目级别
      this.detailedData.Memo21 = ""; //项目归属
      this.detailedData.Memo15 = ""; //分期
      this.detailedData.Memo3 = ""; //适应症
      this.detailedData.Memo11 = ""; //研究科室
      if (item != 1) {
        this.detailedData.ProjectId = item.ProjectId;
        this.searchCRC(1);
      }
    },
    //获取项目列表
    getWorkProjectList() {
      GetObjectList({
        objKey: "zl_getzlproject",
      }).then((res) => {
        if (res.data.Code != 1) this.$message.error(res.data.Msg);
        this.projectList = res.data.Data.Table;
      });
    },
    //带有输入建议
    querySearch(queryString, cb) {
      let transfer = [];
      this.projectList.forEach((item) => {
        item.value = item.ProjectName;
        if (item.value.indexOf(queryString) != -1) {
          transfer.push(item);
        }
      });
      var restaurants = this.projectList;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      if (transfer.length > 0) {
        cb(transfer);
      } else {
        cb(results);
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    //回退路由
    backOff(e) {
      window.opener = null;
      window.close();
    },
    //页面刷新或者关闭 事件  ---用于后期不保存离开提示
    tipMethod(e) {
      // window.onbeforeunload = function (e) {
      if (
        JSON.stringify(this.detailedData) !=
        window.sessionStorage.getItem("detailedData")
      ) {
        var e = window.event || e;
        e.returnValue = "是否确定关闭页面";
      }
      // };
    },
    editPreservation() {
      this.$message.success("保存成功");
    }, // 工作地
    async getCitiesCascaderOption() {
      await AllCitiesCascaderOption(null).then((res) => {
        if (res.data.Code != 1) return;
        this.cityCascaders = res.data.Data;
      });
    },
    editClick(item) {
      console.log(item);
    },
    fileClick() {
      this.$confirm("是否归档", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning",
      }).then(() => {
        let params = {
          CallReportId: this.detailedData.CallReportId,
          AuthType: 4,
          AuthResult: 1,
          AuthComments: "",
        };
        AuthCallList(params).then((res) => {
          this.editLoading = false;
          if (res.data.Code == -1) return this.$message.error(res.data.Msg);
          this.$message.success("归档成功!");
          window.sessionStorage.setItem(
            "detailedData",
            JSON.stringify(this.detailedData)
          );
          window.opener.postMessage("refash", window.location);
          setTimeout(() => {
            window.close();
          }, 500);
        });
      });
    },
    refuseTotal() {
      console.log( this.$refs.childs.callMethod());
      
      if (this.$refs.childs.callMethod()[0] == 1){
        const ItemLabel = this.$refs.childs.callMethod()[1];
        this.$refs.childs.setFocus(ItemLabel, 1); // 自动聚焦
        return this.$message.error(`${ItemLabel}  请填写完整`);
      }
      if (this.$refs.childs.callMethod()[0] == 2) {
        const ItemLabel = this.$refs.childs.callMethod()[1];
        this.$refs.childs.setFocus(ItemLabel, 2); // 自动聚焦
        return this.$message.error(`${ItemLabel}  请填写拒绝原因`);
      }
      if (!this.AuthComments) {
        this.$refs.AuthCommentsref.focus()
        return this.$message.error("请填写备注");
      }
      let params = {
        IMPCallDetailDataModel: this.$refs.childs.callMethod(),
        CallReportId: this.detailedData.CallReportId,
        AuthType: this.stateName == "待PM审核" ? 2 : 3,
        AuthResult: 2,
        AuthComments: this.AuthComments,
      };
      params.IMPCallDetailDataModel.forEach((v) => {
        if (Array.isArray(v.Memo9)) {
        v.Memo9 = v.Memo9.join(",");
        }
      });
      
      
      this.editLoading = true;
      AuthCallList(params).then((res) => {
        if (res.data.Code == -1) {
          this.editLoading = false;
          return this.$message.error(res.data.Msg);
        }
        this.$message.success("提交成功!");
        window.sessionStorage.setItem(
          "detailedData",
          JSON.stringify(this.detailedData)
        );
        window.opener.postMessage("refash", window.location);
        setTimeout(() => {
          window.close();
        }, 500);
      });
    },
    switchCRCClick() {
      this.CRCName = [];
      this.trueCRC = true;
      this.searchCRC(2);
    },
    modifyCRCClick() {
      const detaMemo = [
        {
          Memo6: "",
          Memo7: "",
        },
      ];
      if (
        this.CRCName.length > 0 &&
        this.CRCName.join(",") != this.detailedData.Memo6
      ) {
        this.CRCName.forEach((v, i) => {
          if (this.CRCName.length - 1 == i) {
            detaMemo[0].Memo6 += v.split(",")[1];
            detaMemo[0].Memo7 += v.split(",")[0];
          } else {
            detaMemo[0].Memo6 += v.split(",")[1] + ",";
            detaMemo[0].Memo7 += v.split(",")[0] + ",";
          }
        });
      }
      let params = {
        IMPCallDetailDataModel: detaMemo,
        CallReportId: this.detailedData.CallReportId,
        AuthType: -2,
        AuthResult: 1,
        AuthComments: "",
      };
      this.editLoadingCRC = true;
      AuthCallList(params).then((res) => {
        if (res.data.Code == -1) {
          this.editLoadingCRC = false;
          return this.$message.error(res.data.Msg);
        }
        this.editLoadingCRC = false;
        this.$message.success("CRC修改成功!");
        this.detailedData.Memo6 = detaMemo[0].Memo6;
        this.trueCRC = false;
      });
    },
    agreeTotal() {
      if (this.stateName == "待PM审核" || this.stateName == "待负责人审核") {
        if (this.$refs.childs.callMethod()[0] == 1) {
          const ItemLabel = this.$refs.childs.callMethod()[1];
          this.$refs.childs.setFocus(ItemLabel, 1); // 自动聚焦
          return this.$message.error(ItemLabel + "请填写完整");
        }
        if (this.$refs.childs.callMethod()[0] == 2) {
          const ItemLabel = this.$refs.childs.callMethod()[1];
          this.$refs.childs.setFocus(ItemLabel, 2); // 自动聚焦
          return this.$message.error(ItemLabel + "请填写拒绝原因");
        }
        if (
          this.$refs.childs.callMethod() &&
          this.$refs.childs.callMethod().length > 0
        ) {
          let falseTrue = false;
          const allAgreeMessage = [];
          for (let i = 0; i < this.$refs.childs.callMethod().length; i++) {
            const v = this.$refs.childs.callMethod()[i];
            if (this.stateName == "待PM审核") {
              if (v.Memo12 != "1") {
                falseTrue = true;
                allAgreeMessage.push(v.ItemLabel);
              }
            } else {
              if (v.Memo14 != "1") {
                falseTrue = true;
                allAgreeMessage.push(v.ItemLabel );
              }
            }
          }
          if (falseTrue) {
            return this.$message.error(allAgreeMessage.join('; ') + " 以上全部同意后才能批准");
          }
        }
        let params = {
          IMPCallDetailDataModel: this.$refs.childs.callMethod(),
          CallReportId: this.detailedData.CallReportId,
          AuthType: this.stateName == "待PM审核" ? 2 : 3,
          AuthResult: 1,
          AuthComments: this.AuthComments,
        };
        this.editLoading = true;
        AuthCallList(params).then((res) => {
          if (res.data.Code == -1) {
            this.editLoading = false;
            return this.$message.error(res.data.Msg);
          }
          this.$message.success("提交成功!");
          window.sessionStorage.setItem(
            "detailedData",
            JSON.stringify(this.detailedData)
          );
          window.opener.postMessage("refash", window.location);
          setTimeout(() => {
            window.close();
          }, 500);
        });
      }
    },
    preservation(num, AuthTypeNumber, automatic) {
      console.log(this.$refs.childs.callMethod(),111);
      
      const stateName = sessionStorage.getItem("stateName");
      if (num == 4) {
        sessionStorage.setItem("storageCRC", 1);
      } else {
        sessionStorage.setItem("storageCRC", 2);
      }
      if (
        stateName == "待PM反馈" ||
        stateName == "待CRC整改" ||
        stateName == "待PM审核" ||
        stateName == "待负责人审核"
      ) {
        if (this.$refs.childs.callMethod()[0] == 1) {
          const ItemLabel = this.$refs.childs.callMethod()[1];
          this.$refs.childs.setFocus(ItemLabel, '审核'); // 审核自动聚焦
          return this.$message.error(ItemLabel + " 请将项目详情填写完整");
        }
          
        if (this.$refs.childs.callMethod()[0] == 2) {
          const ItemLabel = this.$refs.childs.callMethod()[1];
          this.$refs.childs.setFocus(ItemLabel, 2); // 自动聚焦
          return this.$message.error(ItemLabel + "拒绝请填写拒绝原因");
        }
        // num == 4 代表是保存草稿
        let params = {
          IMPCallDetailDataModel: this.$refs.childs.callMethod(),
          CallReportId: this.detailedData.CallReportId,
          AuthType: 
            num == 4
              ? -1
              : stateName == "待PM反馈"
              ? 0
              : stateName == "待CRC整改"
              ? 1
              : stateName == "待PM审核"
              ? 2
              : 3,
          AuthResult: 1,
          AuthComments: "",
        };
        params.IMPCallDetailDataModel.forEach((v) => {
        if (Array.isArray(v.Memo9)) {
        v.Memo9 = v.Memo9.join(",");
        }
      });
        if(AuthTypeNumber) {
          params.AuthType = stateName == "待PM审核" ? AuthTypeNumber + 2 : AuthTypeNumber + 3;
        }
        // 自动保存
        if(automatic === 'automatic') {
          //params.IMPCallDetailDataModel111
          AuthCallList(params).then((res) => {
            if (res.data.Code == -1) {
              return this.$message.error('自动保存失败',res.data.Msg);
            }
            this.$message.success("自动保存草稿成功!");
            window.sessionStorage.setItem(
              "detailedData",
              JSON.stringify(this.detailedData)
            );
          });
        } else {
          // 正常保存
          this.editLoading = true;
          AuthCallList(params).then((res) => {
            if (res.data.Code == -1) {
              this.editLoading = false;
              return this.$message.error(res.data.Msg);
            }
            this.$message.success("提交成功!");
            window.sessionStorage.setItem(
              "detailedData",
              JSON.stringify(this.detailedData)
            );
            window.opener.postMessage("refash", window.location);
            setTimeout(() => {
              window.close();
            }, 500);
          });
        }
      } else {
        if (!this.keyGJZ) return this.$message.error("项目名称不能为空");
        if (!this.detailedData.Memo10) return this.$message.error("中心名称不能为空");
        if (this.CRCName.length == 0) return this.$message.error("CRC不能为空");
        if (!this.detailedData.TemplateId) return this.$message.error("报告类型不能为空");

        if (num == 1) {
          this.detailedData.Memo50 = "草稿";
          window.sessionStorage.setItem("stateName", "草稿");
        } else {
          this.detailedData.Memo50 = "待CRC整改";
          window.sessionStorage.setItem("stateName", "不是草稿");
          this.detailedData.CallDate = this.formatDate(new Date());

          // 这次改的 -----开始
          if (!this.detailedData.Memo1)
            return this.$message.error("研究阶段不能为空");
          if (!this.detailedData.Memo2)
            return this.$message.error("质控或核查原因不能为空");
          if (!this.detailedData.Memo3)
            return this.$message.error("适应症不能为空");
          if (!this.detailedData.Memo4)
            return this.$message.error("中心所在城市不能为空");
          if (!this.detailedData.Memo5)
            return this.$message.error("省份不能为空");
          if (!this.detailedData.Memo9)
            return this.$message.error("中心编号不能为空");
          if (!this.detailedData.Memo11)
            return this.$message.error("研究科室不能为空");
          if (!this.detailedData.Memo12)
            return this.$message.error("主要研究者（PI）不能为空");
          if (!this.detailedData.Memo13)
            return this.$message.error("申办方不能为空");
          if (!this.detailedData.Memo14)
            return this.$message.error("普蒂德PM姓名不能为空");
          if (!this.detailedData.Memo15)
            return this.$message.error("试验分期不能为空");
          if (!this.detailedData.Memo16)
            return this.$message.error("核查人员不能为空");
          if (this.detailedDataMemo17.length == 0)
            return this.$message.error("核查日期不能为空");
          if (this.situationProject.length == 0)
            return this.$message.error("项目情况不能为空");
          let situationProjectTrue = 0;
          for (let i = 0; i < this.situationProject.length; i++) {
            if (this.situationProject[i]) {
              situationProjectTrue = 1;
            }
          }
          if (situationProjectTrue != 1) {
            return this.$message.error("项目情况不能为空");
          }
          if (!this.detailedData.Memo22)
            return this.$message.error("核查例数及筛选号不能为空");
          if (this.detailedDataMemo23.length == 0)
            return this.$message.error("核查内容不能为空");
          // 这次改的 -----结束
          if (
            !this.$refs.childs.callMethod() ||
            this.$refs.childs.callMethod().length == 0
          )
            return this.$message.error("项目详情不能为空");

          if (this.$refs.childs.callMethod()[0] == 0) {
            const ItemLabel = this.$refs.childs.callMethod()[1];
            this.$refs.childs.setFocus(ItemLabel, 0); // 自动聚焦
            return this.$message.error(`${ItemLabel}  问题类别不能为空`);
          }
          if (this.$refs.childs.callMethod()[0] == 1) {
            const ItemLabel = this.$refs.childs.callMethod()[1];
            this.$refs.childs.setFocus(ItemLabel, 1); // 自动聚焦
            return this.$message.error(`${ItemLabel}  如选其他请描述`);
          }
          if (this.$refs.childs.callMethod()[0] == 2) {
            const ItemLabel = this.$refs.childs.callMethod()[1];
            this.$refs.childs.setFocus(ItemLabel, 2); // 自动聚焦
            return this.$message.error(`${ItemLabel}  请填写严重程度分级`);
          }
          if (this.$refs.childs.callMethod()[0] == 3) {
            const ItemLabel = this.$refs.childs.callMethod()[1];
            this.$refs.childs.setFocus(ItemLabel, 0); // 自动聚焦
            return this.$message.error(`${ItemLabel}  如填写其他，请补充完整`);
          }
        }
        if (this.detailedDataMemo23.length > 0) {
          this.detailedData.Memo23 = this.detailedDataMemo23.join(",");
        }
        
        this.detailedData.ProjectCode = this.keyGJZ;
        this.detailedData.Memo17 = this.detailedDataMemo17.join(",");
        this.detailedData.CallReportDetail = this.$refs.childs.callMethod();
        this.detailedData.Memo18 = this.situationProject.join(",");
        if (
          this.CRCName.length > 0 &&
          this.CRCName.join(",") != this.detailedData.Memo6
        ) {
          this.detailedData.Memo6 = "";
          this.detailedData.Memo7 = "";
          this.CRCName.forEach((v, i) => {
            if (this.CRCName.length - 1 == i) {
              this.detailedData.Memo7 += v.split(",")[0];
              this.detailedData.Memo6 += v.split(",")[1];
            } else {
              this.detailedData.Memo7 += v.split(",")[0] + ",";
              this.detailedData.Memo6 += v.split(",")[1] + ",";
            }
          });
        }
        this.editLoading = true;
        SetQualityRptList(this.detailedData).then((res) => {
          if (res.data.Code == -1) {
            this.editLoading = false;
            return this.$message.error(res.data.Msg);
          }
          this.$message.success(num == 1 ? "保存草稿成功!" : "发布成功!");
          window.sessionStorage.setItem(
            "detailedData",
            JSON.stringify(this.detailedData)
          );
          window.opener.postMessage("refash", window.location);
          setTimeout(() => {
            window.close();
          }, 500);
        });
      }
    },

    exportExcel() {
      this.exportLoading = true;
      import("./templateExport/exportExcel").then((excel) => {
        // const tHeader = ["项目信息"];
        const tHeader = [
          "项目名称：",
          this.detailedData.ProjectCode,
          "中心名称：",
          this.detailedData.Memo10,
          "CRC：",
          this.detailedData.Memo6,
          "项目部门：",
          this.detailedData.Memo19,
          "中心编号：",
          this.detailedData.Memo9,
          "申办方：",
          this.detailedData.Memo13,
          "中心名称：",
          this.detailedData.Memo10,
          "项目经理：",
          this.detailedData.Memo14,
          "项目级别：",
          this.detailedData.Memo20,
          "项目归属：",
          this.detailedData.Memo21,
        ]; //表头
        const filterVal = [
          "ItemLabel",
          "Memo1",
          "Memo2",
          "Memo3",
          "Memo4",
          "Memo5",
          "Memo6",
          "Memo11",
          "Memo7",
          "Memo8",
          "Memo9",
          "Memo10",
          "Memo12",
          "Memo13",
          "Memo14",
          "Memo15",
          "Memo16",
          "Memo17",
          "Memo18",
          "Memo19",
        ]; //字段
        const title = [`项目信息`]; //标题

        let add = [
          {
            ItemLabel: "项目报告",
          },
          {
            ItemLabel: "报告类型：",
            Memo1:
              this.detailedData.TemplateId == 1
                ? "QA报告"
                : this.detailedData.TemplateId == 2
                ? "QC报告"
                : "Co-v报告",
            Memo2: "研究阶段：",
            Memo3: this.detailedData.Memo1,
            Memo4: "质控或核查原因：",
            Memo5: this.detailedData.Memo2,
            Memo6: "适应症：",
            Memo11: this.detailedData.Memo3,
            Memo7: "中心所在城市：",
            Memo8: this.detailedData.Memo4,
            Memo9: "省份：",
            Memo10: this.detailedData.Memo5,
            Memo12: "crc直线汇报领导：",
            Memo13: this.detailedData.Memo8,
            Memo14: "中心编号：",
            Memo15: this.detailedData.Memo9,
            Memo16: "中心名称：",
            Memo17: this.detailedData.Memo10,
            Memo18: "研究科室",
            Memo19: this.detailedData.Memo11,
          },
          {
            ItemLabel: "主要研究者（PI）：",
            Memo1: this.detailedData.Memo12,
            Memo2: "申办方：",
            Memo3: this.detailedData.Memo13,
            Memo4: "普蒂德PM姓名：",
            Memo5: this.detailedData.Memo14,
            Memo6: "试验分期：",
            Memo11: this.detailedData.Memo15,
            Memo7: "报告发出日期：",
            Memo8: this.detailedData.CallDate,
            Memo9: "核查人员：",
            Memo10: this.detailedData.Memo16,
            Memo12: "核查日期：",
            Memo13: this.detailedData.Memo17,
            Memo14: "报告撰写者：",
            Memo15: this.detailedData.UserName,
            Memo16: "核查例数及筛选号：",
            Memo17: this.detailedData.Memo22,
            Memo18: "核查内容：",
            Memo19: this.detailedData.Memo23,
          },
          {
            ItemLabel: "项目情况：",
            Memo1: `筛选（${
              this.situationProject[0] ? this.situationProject[0] : 0
            }）例`,
            Memo2: `入组（${
              this.situationProject[1] ? this.situationProject[1] : 0
            }）例`,
            Memo3: `在随访（${
              this.situationProject[2] ? this.situationProject[2] : 0
            }）例`,
            Memo4: `完成（${
              this.situationProject[3] ? this.situationProject[3] : 0
            }）例`,
            Memo5: `脱落（${
              this.situationProject[4] ? this.situationProject[4] : 0
            }）例`,
            Memo6: `疾病进展出组（${
              this.situationProject[5] ? this.situationProject[5] : 0
            }）例`,
            Memo11: `生存随访（${
              this.situationProject[6] ? this.situationProject[6] : 0
            }）例`,
            Memo7: `死亡（${
              this.situationProject[7] ? this.situationProject[7] : 0
            }）例`,
            Memo8: `其中SAE（${
              this.situationProject[8] ? this.situationProject[8] : 0
            }）例`,
          },

          {
            ItemLabel: "项目报告",
          },
          {
            ItemLabel: "内容分类",
            Memo1: "问题类别",
            Memo2: "其他问题类别（如选择“其他”请描述）",
            Memo3: "严重程度分级",
            Memo4: "问题描述",
            Memo5: "参考依据",
            Memo6: "纠正和预防措施",
            Memo11: "责任人",
            Memo7: "计划完成日期",
            Memo8: "实际完成日期",
            Memo9: "文件资料支持（如需）",
            Memo10: "备注（无需整改或未能整改的在此说明）",
            Memo12: "PM审核",
            Memo13: "审核意见",
            Memo14: "负责人审核",
            Memo15: "负责人审核意见",
          },
        ];

        this.TemplateData2.forEach((item) => {
          add.push({
            ItemLabel: item.ItemLabel,
            Memo1: item.Memo1,
            Memo2: item.Memo2,
            Memo3: item.Memo3,
            Memo4: item.Memo4,
            Memo5: item.Memo5,
            Memo6: item.Memo6,
            Memo11: item.Memo11,
            Memo7: item.Memo7,
            Memo8: item.Memo8,
            Memo9: item.Memo9,
            Memo10: item.Memo10,
            Memo12: item.Memo12 == 1 ? "同意" : item.Memo12 == 2 ? "拒绝" : "",
            Memo13: item.Memo13,
            Memo14: item.Memo14 == 1 ? "同意" : item.Memo14 == 2 ? "拒绝" : "",
            Memo15: item.Memo15,
          });
        });
        //表头对应字段数据
        const list = add;
        const data = this.formatJson(filterVal, list);
        data.map((item) => {
          item.map((i, index) => {
            if (!i) {
              item[index] = "";
            }
          });
        });
        const uid = [
          "A",
          "B",
          "C",
          "D",
          "E",
          "F",
          "G",
          "H",
          "I",
          "J",
          "K",
          "L",
          "M",
          "N",
          "O",
          "P",
          "Q",
          "R",
          "S",
          "T",
          "U",
          "V",
          "W",
          "X",
          "Y",
          "Z",
        ];
        var zimu = "";
        let lengthNum = 19;
        if (lengthNum > 24) {
          zimu = "A" + uid[lengthNum - 24];
        } else {
          zimu = uid[lengthNum];
        }
        // const merges = [`A1:${zimu}1`, 'A6:C6', 'A10:C10', 'A14:C14', 'A18:C18', 'A22:C22', 'A23:C23', 'A3:A5', 'A7:A9', 'A11:A13', 'A15:A17', 'A19:A21', 'B3:B5', 'B7:B9', 'B11:B13', 'B15:B17', 'B19:B21'] //合并单元格
        const merges = [`A1:${zimu}1`, `A3:${zimu}3`, `A7:${zimu}7`]; //合并行
        excel.export_json_to_excel({
          title: title,
          header: tHeader,
          data,
          merges,
          filename: "质量报告_" + this.formatDate(new Date()),
          autoWidth: true,
          bookType: "xlsx",
          myRowFont: "2",
        });
        this.exportLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>

<style lang="scss" scoped>
.bodys {
  padding: 0 20px;
  padding-bottom: 20px;
  font-size: 12px;
  min-width: 1400px;
}
.box {
  //   width: 98%;
  //   padding: 10px;
  //   border-radius: 5px;
  //   margin: 20px 0;
}
.box_top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 10px;
}
.box_topA {
  cursor: pointer;
  color: #4696fc;
  border: 1px solid #4696fc;
  user-select: none;
  padding: 2px 10px;
  border-radius: 5px;
}
.box_h3 {
  color: #4696fc;
  font-weight: bold;
}
.aboutDiv {
  display: flex;
  flex-direction: column;
  /deep/ .el-input__inner {
    line-height: 30px;
    height: 30px;
  }
}
.projectStyle {
  /deep/ .el-input {
    width: 300px;
  }
}
.aboutDiv > div {
  margin-right: 30px;
  display: flex;
  justify-content: flex-start;
}
.aboutDiv > div > div {
  display: flex;
  justify-content: flex-start;
  height: 40px;
  line-height: 40px;
  min-width: 150px;
}
.aboutDiv > div > div p {
  width: 60px;
  text-align: right;
  margin-right: 10px;
  color: #76767a;
}
.tableStyle {
  min-width: 1300px;
  width: 100%;
  border-collapse: collapse;
  /deep/ .el-cascader {
    height: 25px;
    line-height: 25px;
  }
  /deep/ .el-input__inner {
    height: 25px;
    line-height: 25px;
    border: 0px solid #dcdfe6;
    padding: 0 5px;
  }
  /deep/ .el-input__prefix {
    display: none;
  }
  /deep/ .el-input__icon {
    height: 25px;
    line-height: 25px;
  }
}
td,
th {
  line-height: 20px;
  height: 20px;
  border: 1px solid #ccc;
  text-align: center;
  padding: 5px;
}
th {
  background-color: rgba(221, 221, 221, 0.5);
}
.box_card {
  min-width: 400px;
  margin: 10px 0;
  border-radius: 4px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
  padding: 20px 10px;
  /deep/ .el-breadcrumb {
    margin: 10px 0;
  }
  /deep/ .el-step__title {
    font-size: 12px;
  }
  /deep/ .el-steps--simple {
    padding: 8px 8%;
  }
}
.topBtns {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.topBtn {
  margin-right: 100px;
}
.specialInput {
  // display: flex;
  min-width: 670px;
  /deep/ .el-input__inner {
    width: 40px;
    border: 1px solid #dcdfe6;
    padding: 0 2px;
  }
  /deep/ .el-input {
    width: 40px;
    margin: 0px 3px 2px 3px;
  }
  /deep/ ::-webkit-outer-spin-button,
  /deep/ input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
  /deep/ input[type="number"] {
    -moz-appearance: textfield;
  }
}
.testDiv {
  display: flex;
  justify-content: space-between;
}
.testDiv > div {
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.testDiv > div > div {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.date {
  /deep/ .el-date-editor.el-input {
    width: 132px;
  }
  /deep/ .el-date-editor .el-range-separator {
    line-height: 24px;
    padding: 0 8px 0 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/centeruser/reportQualityScreen.vue